import { Type } from '@angular/core';

export interface IDialogComponent extends Type<any> {
  isDismissible: boolean;
  fullScreen?: boolean;
  props: any;
}

export enum BasicDialogButtonsEnum {
  primary,
  secondary,
}

export interface IDialogData {
  component: IDialogComponent;
  props?: any;
}
